module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/199.c06b4e5c.png";